import { apiClient } from './client'
import type { Notification, NotificationListResponse } from '@/types/notification'

export const notificationsApi = {
  /**
   * Get notifications for the authenticated user
   */
  async list(params?: {
    unreadOnly?: boolean
    type?: string
    severity?: string
    page?: number
    pageSize?: number
  }) {
    const response = await apiClient.get<{
      success: boolean
      data: NotificationListResponse
    }>('/notifications', { params })
    return response.data
  },

  /**
   * Get broadcast notifications (for all users)
   */
  async getBroadcasts(params?: { page?: number; pageSize?: number }) {
    const response = await apiClient.get<{
      success: boolean
      data: NotificationListResponse
    }>('/notifications/broadcasts', { params })
    return response.data
  },

  /**
   * Mark a notification as read
   */
  async markAsRead(id: string) {
    const response = await apiClient.post<{
      success: boolean
      data: Notification
    }>(`/notifications/${id}/read`)
    return response.data
  },

  /**
   * Mark all notifications as read
   */
  async markAllAsRead() {
    const response = await apiClient.post<{
      success: boolean
      data: { count: number }
    }>('/notifications/read-all')
    return response.data
  },
}
